import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "app-sidebar-wrapper__overlay" }, null, -1)
const _hoisted_2 = { id: "sidebar" }
const _hoisted_3 = { class: "sidebar-container" }
const _hoisted_4 = {
  key: 0,
  class: "badlantic"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "group-div" }

import {
  computed,
  ref,
  onBeforeUpdate,
} from 'vue';
import { useStore } from 'vuex';
import SidebarGroup from '@/components/sidebar/SidebarGroup.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'IoSidebar',
  props: {
  items: {
    type: Array,
    required: true,
  },
},
  setup(__props) {

library.add(faArrowRight);



const store = useStore();
const sidebarGroups = ref<InstanceType<typeof SidebarGroup>[]>([]);
const batlanticIcon = window.ioappConfig.badlanticLogo;
const batlanticUrl = window.ioappConfig.badlanticUrl;

onBeforeUpdate(() => {
  sidebarGroups.value = [];
});

const isOpen = computed(() => store.getters['sidebar/open']);

const closeOther = (keepInx: number) => {
  sidebarGroups.value.forEach((sidebarGroup, groupInx) => {
    if (groupInx !== keepInx) {
      sidebarGroup.close();
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-sidebar-wrapper", {'open': isOpen.value}])
  }, [
    _hoisted_1,
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(batlanticUrl))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("a", {
                  href: _unref(batlanticUrl),
                  target: "_blank"
                }, [
                  _createElementVNode("img", { src: _unref(batlanticIcon) }, null, 8, _hoisted_6),
                  _createTextVNode(" badlantic "),
                  _createVNode(_component_FontAwesomeIcon, { icon: "fa-solid fa-arrow-right" })
                ], 8, _hoisted_5)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
            return (_openBlock(), _createBlock(SidebarGroup, {
              key: `sg-1-${index}`,
              level: 1,
              index: index,
              item: item,
              ref_for: true,
              ref: el => { if (el) sidebarGroups.value[index] = el },
              onOpen: ($event: any) => (closeOther(index))
            }, null, 8, ["index", "item", "onOpen"]))
          }), 128))
        ])
      ])
    ])
  ], 2))
}
}

})